import { css } from '@bts-web/utils-style-engine';
import { FC, HTMLAttributes, ReactNode } from 'react';

interface ContentSectionWrapperOwnProps {
  sectionTitle?: string;
  sectionDescription?: string | React.ReactNode;
  children: React.ReactNode;
  id?: string;
  leftAction?: ReactNode;
}

type ContentSectionWrapperProps = ContentSectionWrapperOwnProps &
  Omit<HTMLAttributes<HTMLElement>, keyof ContentSectionWrapperOwnProps>;

const ContentSectionWrapper: FC<ContentSectionWrapperProps> = ({
  children,
  sectionTitle,
  sectionDescription,
  className,
  leftAction,
  id,
  ...restProps
}) => {
  return (
    <section
      className={`${css({
        px: { base: 'small', md: 'medium' },
        pt: { base: 'medium' },
        '&:last-of-type': {
          pb: { base: 'medium' },
        },
      })} ${className ?? ''}`}
      {...(id ? { id } : {})}
      {...restProps}
    >
      {sectionTitle || sectionDescription ? (
        <div
          className={css({
            display: 'flex',
            flexDirection: 'column',
            gap: 'small',
            mb: { base: 'small', md: 'medium' },
          })}
        >
          <div
            className={css({
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
            })}
          >
            {sectionTitle && (
              <h3
                className={css({
                  fontSize: 'headline.small_medium',
                  fontWeight: 'headline.small_medium',
                  letterSpacing: 'headline.small_medium',
                  lineHeight: 'headline.small_medium',
                })}
              >
                {sectionTitle}
              </h3>
            )}

            {leftAction}
          </div>

          {typeof sectionDescription === 'string' ? (
            <span
              className={css({
                fontSize: 'body.medium',
                fontWeight: 'body.medium',
                letterSpacing: 'body.medium',
                lineHeight: 'body.medium',
                color: 'neutrals.text_primary',
              })}
            >
              {sectionDescription}
            </span>
          ) : sectionDescription ? (
            sectionDescription
          ) : null}
        </div>
      ) : null}

      {children}
    </section>
  );
};

export { ContentSectionWrapper };
